"use client";
import { motion } from "framer-motion";
import EsterVideo from "./ester-video";
import Image from "next/image";
import Link from "next/link";
import { ExternalLink } from "lucide-react";

const VirtualAssistant = () => {
  return (
    <section
      id="ester"
      className="py-10 md:py-20 px-6 bg-gradient-primary border-t-2 border-gray-100 max-w-7xl mx-auto text-center"
    >
      <motion.div
        className="flex md:flex-row flex-col w-full justify-between items-center md:gap-x-8 gap-y-2"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <div className="flex md:flex-col flex-col-reverse gap-4">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-primary mb-8 text-start">
              Conheça Ester <br />
              <span className="bg-gradient-to-r from-[hsl(var(--secondary))] to-[hsl(var(--accent))] bg-clip-text text-transparent">
                Nossa Avatar Exclusiva
              </span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed text-left">
              Ester é a nossa avatar exclusiva, criada para dar vida à essência
              da escapa! Ela simboliza inovação, hospitalidade e o encontro
              entre ciência e tecnologia. Com ela, traduzimos o futuro dos
              serviços de luxo em experiências acessíveis e inspiradoras. Já
              imaginou o impacto dos nossos vídeos em IA no seu negócio? Então,
              venha conhecer a escapa!
            </p>
          </div>

          {/* Divider */}
          <div className="w-full my-1 md:my-8">
            <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
          </div>

          <div className="flex flex-col gap-4 w-full">
            <div className="flex flex-col gap-2">
              <h3 className="text-lg md:text-xl font-semibold text-primary">
                Escapa recebe reconhecimento nacional
              </h3>
              <Link
                href="https://www.panrotas.com.br/mercado/tecnologia/2025/10/turismo-ganha-primeira-startup-especializada-em-criacao-de-avatares-e-videos-de-ia_222634.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm md:text-base text-gray-500 hover:text-[hsl(var(--accent))] transition-colors duration-300 self-center"
              >
                <span className="flex flex-row gap-2 items-center">
                  Acesse a matéria completa
                  <ExternalLink className="w-4 h-4" />
                </span>
              </Link>
            </div>
            <div className="flex flex-row gap-3 items-center self-center">
              {[1, 2].map((i) => (
                <div
                  key={i}
                  className="relative group overflow-hidden rounded-lg cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <img
                    src={`/escapa/materia/${i}.jpg`}
                    alt={`Matéria ${i} - Escapa`}
                    className="w-auto h-[200px] md:h-[400px] object-cover transition-transform duration-300 group-hover:scale-101 object-cover position-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute inset-0 border-2 border-white/0 group-hover:border-white/30 transition-all duration-300 rounded-lg"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <EsterVideo />
      </motion.div>
    </section>
  );
};

export default VirtualAssistant;
